import React, { Suspense } from "react";

const HomePage = React.lazy(() => import("../view/editor.jsx"));

const Home = () => {
  return (
    <Suspense fallback={null}>
      <HomePage />
    </Suspense>
  );
};

export default Home;
